// Story 1.19 — defensive UI for an edge case: a stale session cookie
// reaches the Danger Zone page just before the session middleware
// kicks the user out. The worker has already revoked sessions in tx1,
// so in practice the user is unlikely to actually see this panel —
// they'll be 401'd into the login page first. But if they do, the
// message is calm and informational rather than an error.

import type { DeletionRequestStatus } from "./useAccountDeletionStatus";

type CompletedDeletionPanelProps = {
  status: DeletionRequestStatus;
};

export function CompletedDeletionPanel({ status }: CompletedDeletionPanelProps) {
  const completedAt = status.completed_at
    ? new Date(status.completed_at).toLocaleString()
    : "earlier today";

  return (
    <div className="rounded-lg border border-border bg-muted/30 p-6 space-y-3">
      <h2 className="font-heading text-lg font-semibold">
        Your account has been deleted
      </h2>
      <p className="font-body text-sm">
        Anonymization completed at{" "}
        <span className="font-semibold">{completedAt}</span>. Your active
        sessions have been revoked.
      </p>
      <p className="font-body text-sm text-muted-foreground">
        Per EU regulatory requirements (PSD2 + AML), your financial audit-trail
        records are retained for 5 years. Your profile, contact information,
        and session data have been erased.
      </p>
    </div>
  );
}
